<template>
    <div>
        <Select
            ref="selectApiContainer"
            placeholder="Selecione"
            v-model="model"
            :options="list"
            opt-id="id"
            :opt-text="optText"
            @input="changeSelect"
            v-bind:readonly="readonly"
            :disabled="disabled"
        >
            <option value>Selecione</option>
        </Select>
    </div>
</template>
<script>
import Select from "./Select";
import Facade from "../../facade/facade";
const facade = new Facade();

export default {
    components: { Select },
    props: {
        value: [String, Number],
        endpoint: {
            type: String,
            required: true
        },
        params: {
            type: Object
        },
        optText: {
            type: String,
            default: "nome"
        },
        readonly: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            list: [],
            model: null
        };
    },
    async created() {
        try {
            let _params = {};
            if (this.params) {
                _params = this.params;
            }
            const listAPI = await axios.get(this.endpoint, _params);
            this.list = listAPI.data.data;
        } catch (e) {
            throw e;
        }
    },
    watch: {
        value(newVal) {
            this.model = newVal;
            this.$emit("change", newVal);
        }
    },
    methods: {
        changeSelect(newVal) {
            this.$emit("input", newVal);
            this.$emit("change", newVal);
        }
    }
};
</script>



// WEBPACK FOOTER //
// SelectApi.vue?76174fe2